import type { IProduct } from 'types';

export function isProductAvailable(product: IProduct) {
  const { isAvailable } = product || {};
  return isAvailable;
}
